class ArchiveManual {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-hvrImg').on({
      'mouseenter': function() {
        let hvrEl = $(this).attr('data-class');

        $('.js-img img').each(function(index, el) {
          if(el.getAttribute('data-class') == hvrEl) {
            gsap.to(el, .1, {
              opacity: 1,
            })
          }
        })
      },
      'mouseleave': function() {
        let hvrEl = $(this).attr('data-class');

        $('.js-img img').each(function(index, el) {
          if(el.getAttribute('data-class') == hvrEl) {
            gsap.to(el, .1, {
              opacity: 0,
            })
          }
        })
      }
    })
  }
}
